<template>
  <div class="configurable-dialog">
    <div class="configurable-dialog__content" slot="custom">
      <div class="title">
        <p>您已获得</p>
        <p>{{data.discountValue}}天免息红包</p>
      </div>
      <div
        class="configurable-dialog__content__button"
        @click="handleButtonClick"
        v-stat="{
          id: 50022,
          args: {
            target: 'REDUCTION_INTEREST', // 免息活动
            step: data.nextStep,
            position: 1,
            status: mobile ? 1 : 0,
          },
        }"
      >
        惊喜提现
      </div>
      <div
        class="configurable-dialog__content__text-button"
        @click="handleTextButtonClick"
        v-stat="{
          id: 50022,
          args: {
            target: 'REDUCTION_INTEREST', // 免息活动
            step: data.nextStep,
            position: 2,
            status: mobile ? 1 : 0,
          },
        }"
      >
        活动详情 >
      </div>
    </div>
  </div>
</template>
<script>
import { setKey } from '@/assets/utils'

export default {
  data () {
    return {
      visible: true
    }
  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    mobile: String
  },
  methods: {
    show () {
      setKey(`INTEREST_FREE_DIALOG_1_SHOW_TIME${this.mobile}`, Date.now())
      this.$report({
        id: 50021,
        args: {
          visible: 1,
          target: 'REDUCTION_INTEREST', // 免息活动
          step: this.data.nextStep,
          status: this.mobile ? 1 : 0
        }
      })
    },
    open () {
      this.visible = true
      setKey(`INTEREST_FREE_DIALOG_1_SHOW_TIME${this.mobile}`, Date.now())
    },
    close () {
      this.visible = false
      this.$report({
        id: 50022,
        args: {
          target: 'REDUCTION_INTEREST', // 免息活动
          step: this.data.nextStep,
          position: 3,
          status: this.mobile ? 1 : 0
        }
      })
      this.$emit('close')
    },
    handleButtonClick () {
      if (!this.mobile) {
        return this.$router.push('/user/login')
      }
      this.$router.push('/withdraw/index')
    },
    handleTextButtonClick () {
      if (!this.mobile) {
        return this.$router.push('/user/login')
      }
      this.$router.push('/activities/interest-free')
    }
  }
}
</script>
<style lang="less" scoped>
@import "../../../../assets/less/mixin.less";

.configurable-dialog {
    .title{
        text-align: center;
        margin-top:76px;
        >p{
            height: 78px;
            font-size: 56px;
            font-family: DIN-Medium, DIN;
            font-weight: 500;
            color: #FFFFFF;
            line-height: 58px;
        }
    }
    &__content {
        position: relative;
        margin: auto;
        width: 620px;
        height: 750px;
        background: url('../../images/dialog_bg_1.png') center center no-repeat;
        background-size: 100% 100%;

        overflow: hidden;
        &__button {
            position: absolute;
            top: 540px;
            left: 50%;
            transform: translateX(-50%);
            width: 440px;
            height: 80px;
            line-height: 80px;
            border-radius: 40px;
            font-size: 36px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: rgba(255, 255, 255, 1);
            background: linear-gradient(
                90deg,
                rgba(255, 51, 51, 1) 0%,
                rgba(255, 95, 52, 1) 100%
            );
            text-align: center;
        }
        &__text-button {
            position: absolute;
            top: 657px;
            left: 50%;
            transform: translateX(-50%);
            text-align: center;
            font-size: 28px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(255, 70, 51, 1);
        }
    }
}
</style>
